import { z } from 'zod';
import { SORT_BY, SORT_ORDER, UPDATE_PHASE } from '../constnats/tableUpdate';

const updatePhaseSchema = z.nativeEnum(UPDATE_PHASE);

export type UpdatePhaseType = z.infer<typeof updatePhaseSchema>;

export const tableUpdateInfoSchema = z.object({
    id: z.number(),
    description: z.string(),
    summary: z.string(),
    purpose: z.string(),
    phase: updatePhaseSchema,
    ownerId: z.number(),
    companyId: z.number(),
    srcSchemaId: z.number(),
    minFullChecks: z.number(),
    minVisualChecks: z.number(),
    minCDChecks: z.number(),
    reviewRequirementsManagedBy: z.string(),
    reviewRevisionRequestsCount: z.number(),
    mistakePointsFromPeer: z.number().nullable(),
    mistakePointsFromQa: z.number().nullable(),
    cellsScope: z.number().nullable(),
    addedReports: z.number().nullable(),
    totalReports: z.number().nullable(),
    createdOn: z.string(),
    updatedOn: z.string(),
});

export type TableUpdateInfoType = z.infer<typeof tableUpdateInfoSchema>;

export const tableUpdateFiltersSchema = z.object({
    srcSchema: z.number().optional(),
    phases: z.array(updatePhaseSchema).optional(),
    notPhase: updatePhaseSchema.optional(),
    owner: z.number().optional(),
    assignee: z.number().optional(),
    appliedAfter: z.number().optional(),
    appliedBefore: z.number().optional(),
    page: z.number(),
    sortBy: z.nativeEnum(SORT_BY),
    order: z.nativeEnum(SORT_ORDER),
});

export type TableUpdateFiltersType = z.infer<typeof tableUpdateFiltersSchema>;

export type TableUpdateFiltersWithoutPage = Omit<TableUpdateFiltersType, 'page'>;
